

import React, { useEffect } from "react";
import {
    Container,
    Typography,
    Box,
    Divider,
    Grid,
    Link as MuiLink,
} from "@mui/material";


const Seccion_Politicas = () => {

    useEffect(() => {
        document.title = "Política de Privacidad | Diego Polo Tecnología";
        const meta = document.querySelector('meta[name="description"]');
        const description =
            "Política de Privacidad de Diego Polo Tecnología: cómo recolectamos, usamos y protegemos tus datos. Información sobre cookies, derechos y contacto.";
        if (meta) {
            meta.setAttribute("content", description);
        } else {
            const m = document.createElement("meta");
            m.name = "description";
            m.content = description;
            document.head.appendChild(m);
        }
    }, []);

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Política de Privacidad - Diego Polo Tecnología",
        "url": "https://www.diegopolotecnologia.com/politica-de-privacidad",
        "description":
            "Política de Privacidad de Diego Polo Tecnología: cómo recolectamos, usamos y protegemos tus datos.",
    };

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Container maxWidth="md" sx={{ py: 8, maxWidth:1400, px:3}}>
                {/* JSON-LD para SEO */}
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
                />

                <Typography variant="h3" component="h1" gutterBottom>
                    Política de Privacidad
                </Typography>

                <Typography variant="subtitle1" color="text.secondary" paragraph>
                    Última actualización: <strong>01 de septiembre de 2025</strong>
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        Introducción
                    </Typography>
                    <Typography variant="body1" paragraph>
                        En <strong>Diego Polo Tecnología</strong> (en adelante, “nosotros” o
                        “el sitio”) respetamos tu privacidad y nos comprometemos a proteger tus
                        datos personales. Esta política explica qué datos recogemos, con qué
                        finalidad, cómo los usamos y cuáles son tus derechos.
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        1. Responsable del tratamiento
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Responsable: <strong>Diego Polo Tecnología</strong>.
                        <br />
                        Contacto:{" "}
                        <MuiLink href="mailto:contacto@diegopolotecnologia.com">
                            contacto@diegopolotecnologia.com
                        </MuiLink>
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        2. Datos que recopilamos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Podemos recopilar y procesar los siguientes datos:
                    </Typography>
                    <ul>
                        <li>Datos de contacto: nombre, correo electrónico, teléfono.</li>
                        <li>
                            Datos técnicos: dirección IP, tipo de dispositivo, navegador,
                            sistema operativo y páginas visitadas (logs del servidor).
                        </li>
                        <li>Información que nos facilitas en formularios (por ejemplo, CV).</li>
                        <li>Preferencias y consentimientos (cookies y opciones del usuario).</li>
                    </ul>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        3. Finalidad del tratamiento
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Tratamos tus datos para los siguientes fines:
                    </Typography>
                    <ul>
                        <li>Responder a tus consultas y solicitudes de información.</li>
                        <li>Gestión de contactos profesionales y envíos de información
                            (newsletter) —cuando hayas dado tu consentimiento—.</li>
                        <li>Mejorar la experiencia del sitio, analizar el uso y prevenir fraudes.</li>
                        <li>Gestionar procesos de contratación y evaluación de candidaturas si
                            envías tu CV.</li>
                    </ul>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        4. Base legal
                    </Typography>
                    <Typography variant="body1" paragraph>
                        La base legal para el tratamiento puede ser:
                    </Typography>
                    <ul>
                        <li>Tu consentimiento (por ejemplo, suscripción a newsletter).</li>
                        <li>La ejecución de medidas precontractuales o contractuales.</li>
                        <li>El cumplimiento de obligaciones legales.</li>
                        <li>Intereses legítimos (por ejemplo, seguridad, prevención de fraude).</li>
                    </ul>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        5. Cookies y tecnologías similares
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Nuestro sitio utiliza cookies propias y de terceros para mejorar la
                        experiencia de usuario, analizar tráfico y mostrar contenidos
                        personalizados. Puedes gestionar o rechazar cookies desde la
                        configuración de tu navegador o desde el aviso de cookies del sitio.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Ejemplos: cookies de sesión, persistentes, de analítica (Google
                        Analytics) y de servicios externos (mapas, widgets).
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        6. Destinatarios y cesiones
                    </Typography>
                    <Typography variant="body1" paragraph>
                        No vendemos tus datos. Podemos compartir información con proveedores
                        técnicos que prestan servicios (hosting, analítica, envío de correo),
                        siempre bajo acuerdos que garanticen confidencialidad y seguridad.
                        También podemos ceder datos cuando lo exija la ley o una autoridad
                        competente.
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        7. Conservación de los datos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Conservaremos tus datos mientras exista la finalidad que motivó su
                        recogida y durante los plazos legales aplicables. Para los datos de
                        contacto y suscriptores, se mantendrán hasta que solicites la
                        supresión.
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        8. Seguridad
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Adoptamos medidas técnicas y organizativas para proteger tus datos
                        frente al acceso no autorizado, modificación, divulgación o
                        destrucción. Sin embargo, recuerda que ninguna transmisión por
                        internet es 100% segura.
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        9. Tus derechos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Tienes derecho a solicitar: acceso, rectificación, supresión,
                        limitación del tratamiento, oposición y portabilidad de tus datos. Para
                        ejercerlos, puedes escribir a{" "}
                        <MuiLink href="mailto:contacto@diegopolotecnologia.com">
                            contacto@diegopolotecnologia.com
                        </MuiLink>
                        . Responderemos en los plazos legales aplicables.
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        10. Menores
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Nuestro sitio no está dirigido a menores de 13 años. Si eres
                        progenitor o tutor y crees que tenemos datos de un menor, contáctanos
                        para su eliminación.
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        11. Cambios en la política
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Esta política puede actualizarse. Publicaremos la fecha de la última
                        versión en la parte superior y avisaremos cuando las modificaciones
                        sean relevantes.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            Contacto
                        </Typography>
                        <Typography variant="body2">
                            Diego Polo Tecnología
                            <br />
                            Email:{" "}
                            <MuiLink href="mailto:contacto@diegopolotecnologia.com">
                                contacto@diegopolotecnologia.com
                            </MuiLink>
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            Recursos legales
                        </Typography>
                        <Typography variant="body2">
                            Para reclamaciones puedes contactar a la autoridad de protección de
                            datos correspondiente de tu país.
                        </Typography>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                        Versión: 1.0 — Política redactada para fines informativos. Este texto no
                        sustituye asesoría legal profesional. Para adaptarla a regulaciones
                        específicas (por ejemplo, RGPD o leyes locales), consulta a un
                        asesor.
                    </Typography>
                </Box>
            </Container>
        </Grid>
    )

}
export default Seccion_Politicas